// Digital Marketing Course Data

const digitalMarketingCourse = {
  id: 'digital-marketing',
  title: 'Digital Marketing Training & Internship Program',
  shortTitle: 'Digital Marketing',
  hero: {
    headline: 'Digital Marketing Training and Internship - Certificate Program',
    subheadline: 'UK Industry-Microsoft Partnered Certified Program | Campaign Portfolio | Live Interactive Mentorship',
    description: 'Master SEO, social media, content marketing and analytics with Int-Elligence Tech Solutions Plc!',
    statistics: [
      { value: '88%', label: 'of UK companies invest in digital marketing', ref: 'IAB UK' },
      { value: '£28K-£50K', label: 'starting salaries for digital marketers', ref: 'Marketing Week' },
      { value: '3.2x', label: 'growth in digital marketing roles since 2020', ref: 'LinkedIn' }
    ]
  },
  importantNotice: {
    title: '⚠️ IMPORTANT NOTICE',
    requirements: [
      'Treat this as a career accelerator, not just a certificate.',
      'Are prepared for real marketing campaigns with KPIs.',
      'Proactively seek campaign feedback and optimization tips.'
    ],
    reason: 'Our mentors invest 30+ hours per student - we prioritize those serious about digital marketing careers.'
  },
  programHighlights: {
    duration: '3 Months',
    features: [
      {
        icon: '✅',
        title: '1. Multi-Channel Marketing',
        description: 'Master SEO, SEM, social media, email and content marketing'
      },
      {
        icon: '✅',
        title: '2. Weekly Campaign Reviews',
        description: 'UK-based marketing professionals review your campaigns weekly, providing optimization insights'
      },
      {
        icon: '✅',
        title: '3. Industry Expert Mentors',
        description: 'Learn from marketers who manage campaigns for major UK brands'
      },
      {
        icon: '✅',
        title: '4. Microsoft-Partnered Certification',
        description: 'Industry-recognized digital marketing certification'
      },
      {
        icon: '✅',
        title: '5. Real Campaigns',
        description: 'Run actual marketing campaigns for real businesses'
      },
      {
        icon: '✅',
        title: '6. Analytics Mastery',
        description: 'Learn Google Analytics, SEMrush, and data-driven optimization'
      }
    ]
  },
  toolsCovered: [
    { name: 'Google Analytics', description: 'Track and analyze website performance', image: null },
    { name: 'SEO Tools', description: 'SEMrush, Ahrefs for search optimization', image: null },
    { name: 'Social Media Ads', description: 'Facebook Ads, Instagram, LinkedIn campaigns', image: null },
    { name: 'Content Marketing', description: 'WordPress, content strategy and creation', image: null },
    { name: 'Email Marketing', description: 'Mailchimp, automation and segmentation', image: null }
  ],
  whyThisProgram: [
    {
      title: 'High Demand Field',
      description: 'Every UK business needs digital marketing professionals.'
    },
    {
      title: 'Industry Tools',
      description: 'Learn the exact tools used by top UK marketing agencies.'
    },
    {
      title: 'Experienced Marketers',
      description: 'Learn from professionals who manage 6-figure budgets.'
    },
    {
      title: 'Portfolio of Campaigns',
      description: 'Build a portfolio showing real results and ROI.'
    },
    {
      title: 'Career Pathways',
      description: 'Multiple career paths: SEO, PPC, social media, content.'
    },
    {
      title: 'UK Market Focus',
      description: 'Understand UK consumer behavior and market trends.'
    }
  ],
  programDetails: {
    overview: {
      title: 'Program Overview and Duration',
      description: 'Our Digital Marketing Training and Internship - Certificate Program covers all major digital channels. 3 months of comprehensive training:',
      phases: [
        {
          title: 'First 2 months',
          description: 'Learn SEO, SEM, social media marketing, email marketing, and analytics through hands-on mini-campaigns.'
        },
        {
          title: 'Final month',
          description: 'Run full marketing campaigns for real clients across multiple channels - perfect for your portfolio.'
        }
      ]
    },
    modeOfDelivery: {
      title: 'Mode of Delivery',
      description: 'Fully remote with self-paced learning, campaign projects, and weekly strategy sessions. Unpaid learning-focused program.'
    },
    commitment: {
      title: 'Commitment and Flexibility',
      description: 'Expect 8 hours per week minimum for learning, campaign creation, and optimization work.'
    },
    curriculum: {
      title: 'Curriculum and Hands-On Experience',
      description: 'Learn all major digital marketing channels:',
      points: [
        'Master SEO, PPC, social media advertising, and email marketing fundamentals.',
        'Create and optimize mini-campaigns with mentor guidance.',
        'Run multi-channel campaigns in the final phase with real budgets and KPIs.'
      ]
    },
    mentorship: {
      title: 'Mentorship',
      description: 'Weekly 1:1 sessions (30-45 minutes) with UK-based marketing professionals for campaign reviews and strategy optimization.'
    },
    certification: {
      title: 'Certification and Credentials',
      description: 'Microsoft-Partnered Certificate validates your digital marketing expertise across all channels.'
    },
    careerAdvancement: {
      title: 'Career Advancement',
      description: 'Top performers may work on our client campaigns or join our marketing team.',
      additionalInfo: 'Our alumni work at agencies, in-house teams, and as freelance consultants across the UK.',
      careerPaths: 'Career roles include SEO Specialist, PPC Manager, Social Media Manager, Content Strategist, and Digital Marketing Manager.'
    }
  },
  whoShouldApply: [
    {
      icon: '🔹',
      title: 'Marketing Enthusiasts',
      description: 'Launch your digital marketing career.'
    },
    {
      icon: '🔹',
      title: 'Business Owners',
      description: 'Learn to market your own business effectively.'
    },
    {
      icon: '🔹',
      title: 'Career Switchers',
      description: 'Enter the fast-growing marketing field.'
    }
  ],
  aluminiVideos: [
    {
      id: 1,
      name: "Yemisi",
      videoUrl: "https://pub-1a559929ef4149c4abff31d55531033a.r2.dev/yemisi%20(2).mp4",
    },
    {
      id: 2,
      name: "Afifa",
      videoUrl: "https://pub-1a559929ef4149c4abff31d55531033a.r2.dev/afifa.mp4",
    },
    {
      id: 3,
      name: "Obanla",
      videoUrl: "https://pub-1a559929ef4149c4abff31d55531033a.r2.dev/obanla.mp4",
    },
  ],
  whyAlumniGetHired: [
    {
      icon: '✅',
      title: 'Real Campaign Results',
      description: 'Portfolio showing actual ROI and conversions'
    },
    {
      icon: '✅',
      title: 'Multi-Channel Skills',
      description: 'Master SEO, PPC, social, email, and content'
    },
    {
      icon: '✅',
      title: 'Analytics Proficiency',
      description: 'Data-driven decision making and reporting'
    },
    {
      icon: '✅',
      title: 'Industry Tools',
      description: 'Certified in Google Analytics, Ads, and more'
    }
  ],
  testimonialLink: 'https://share.google/wv45vd8NA35pedVmw',
  contactEmail: 'hr@int-elligence.co.uk',
  footerNote: 'UK digital marketing spend exceeds £20B annually - join the industry!'
};

export default digitalMarketingCourse;